module.exports = __webpack_public_path__ + "img/curso-escritorio.62e3a9ad.png";